import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null,
    bsw: null,
    acceptflg: null,
    termstext: null,
    region: '',
    products: [],
    initymd: null
  }),
  actions: {
    setToken (newToken) {
      this.token = newToken
    },
    clearToken () {
      this.token = null
    },
    setBsw (newBsw) {
      this.bsw = newBsw
    },
    clearBsw () {
      this.bsw = null
    },
    setAcceptFlg (newAcceptFlg) {
      this.acceptflg = newAcceptFlg
    },
    clearAcceptFlg () {
      this.acceptflg = null
    },
    setTermstext (newTermstext) {
      this.termstext = newTermstext
    },
    clearTermstext () {
      this.termstext = null
    },
    setRegion (newRegion) {
      this.region = newRegion
    },
    clearRegion () {
      this.region = null
    },
    setProducts (newProducts) {
      this.products = newProducts
    },
    clearnewProducts () {
      this.products = {}
    },
    setInitymd (newInitymd) {
      this.initymd = newInitymd
    },
    clearInitymd () {
      this.initymd = null
    }
  }
})
